import TextField from './TextField';
import maxLengthWrapper from './maxLengthWrapper';
export default maxLengthWrapper(TextField);